module.exports = __webpack_public_path__ + "img/202412_03.ceac4c29.jpg";